/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short, timed focus sessions reduce distraction and mental fatigue, making it easier to start tasks and sustain concentration.`)
};

const es_timer_pomodoro_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las sesiones de enfoque cortas y cronometradas reducen la distracción y la fatiga mental, facilitando comenzar tareas y mantener la concentración.`)
};

const de_timer_pomodoro_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurze, zeitlich begrenzte Fokus-Sessions verringern Ablenkung und mentale Erschöpfung, wodurch es leichter fällt, Aufgaben zu beginnen und die Konzentration zu halten.`)
};

const nl_timer_pomodoro_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korte, getimede focussessies verminderen afleiding en mentale vermoeidheid, waardoor het makkelijker wordt om taken te beginnen en de concentratie vast te houden.`)
};

const fr_timer_pomodoro_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des sessions de concentration courtes et chronométrées réduisent les distractions et la fatigue mentale, ce qui facilite le démarrage des tâches et le maintien de la concentration.`)
};

const it_timer_pomodoro_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessioni di concentrazione brevi e cronometrate riducono le distrazioni e la fatica mentale, rendendo più facile iniziare i compiti e mantenere la concentrazione.`)
};

const pt_br2_timer_pomodoro_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessões de foco curtas e cronometradas reduzem distrações e fadiga mental, facilitando começar tarefas e manter a concentração.`)
};

const pt_timer_pomodoro_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessões de foco curtas e cronometradas reduzem a distração e a fadiga mental, tornando mais fácil começar tarefas e manter a concentração.`)
};

const ja_timer_pomodoro_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短く時間を区切った集中セッションは、気が散る要因や精神的な疲労を減らし、作業に取りかかりやすく、集中力を維持しやすくします。`)
};

const zh_timer_pomodoro_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短时、有明确时限的专注时段能减少分心和精神疲劳，让你更容易开始任务并保持专注。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_faq2_a", locale)
	if (locale === "en") return en_timer_pomodoro_faq2_a(inputs)
	if (locale === "es") return es_timer_pomodoro_faq2_a(inputs)
	if (locale === "de") return de_timer_pomodoro_faq2_a(inputs)
	if (locale === "nl") return nl_timer_pomodoro_faq2_a(inputs)
	if (locale === "fr") return fr_timer_pomodoro_faq2_a(inputs)
	if (locale === "it") return it_timer_pomodoro_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_faq2_a(inputs)
	if (locale === "pt") return pt_timer_pomodoro_faq2_a(inputs)
	if (locale === "ja") return ja_timer_pomodoro_faq2_a(inputs)
	return zh_timer_pomodoro_faq2_a(inputs)
};